import get from 'lodash/get';
import { CORE_BASIC_SERVICE_URI } from '../config/apiConfig';

export function addFeatureMarkImage() {
    setTimeout(() => {
        // const supported = window.TextEncoder && revertString('ylbmessAbeW') in window;
        const supported = true; // 暂时关闭这个逻辑
        if (!supported) {
            const uid = get(window, 'zPREFACE.accountInfo.account_id');
            if (uid) {
                const src = `${CORE_BASIC_SERVICE_URI}/core-basic-api/analytics/security/image.png?id=${uid}&was=false`;
                new Image().src = src;
            }
        }
    }, 3000);
}

function revertString(str) {
    return str.split('').reverse().join('');
}
